module.exports = __webpack_public_path__ + "img/contacts_plus_inactive.d9763f5b.png";